export type WorkspaceSwitcherOrganization = {
  readonly organization_id: string;
  readonly name: string;
  readonly lifecycle_state: "active" | "suspended" | "archived";
  readonly role: string;
};

export function workspaceSwitcherOrganizations(
  memberOrganizations: readonly {
    readonly organization_id: string;
    readonly name: string;
    readonly lifecycle_state: "active" | "suspended" | "archived";
    readonly role: "org_owner" | "org_admin" | "member";
  }[],
): readonly WorkspaceSwitcherOrganization[] {
  return memberOrganizations.map((organization) => ({
    organization_id: organization.organization_id,
    name: organization.name,
    lifecycle_state: organization.lifecycle_state,
    role: organization.role.replace("org_", ""),
  }));
}

export function workspaceEntryPath(input: {
  readonly section: "knowledge" | "admin";
  readonly memberOrganizations: readonly { readonly organization_id: string }[];
  readonly isOperator: boolean;
}): string | null {
  const firstMember = input.memberOrganizations[0];
  if (firstMember !== undefined) {
    return `/org/${firstMember.organization_id}/${input.section}`;
  }
  if (input.isOperator) return "/admin";
  return null;
}

export function workspaceSwitcherNeedsMenu(membershipCount: number): boolean {
  return membershipCount > 1;
}

export function foreignOrganizationRedirect(input: {
  readonly isOperator: boolean;
}): string {
  return input.isOperator ? "/admin" : "/";
}
